// Librairies
import { DecimalPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';

// Components
import { SpinnerComponent } from '../../spinner/spinner.component';

// Blocking progress popup: steps (currentStage / totalStages) or a percent (progress).
@Component({
  selector: 'app-loading-popup',
  templateUrl: './loading-popup.component.html',
  styleUrls: ['./loading-popup.component.scss'],
  imports: [
    DecimalPipe,
    MatProgressBarModule,
    SpinnerComponent
  ],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class LoadingPopupComponent {
  // Variables
  @Input() title: string = '';
  @Input() totalStages: number = 0;
  @Input() currentStage: number = 0;
  @Input() stageTitle: string = '';
  @Input() progress: number | null = null;

  // Percent shown: given, else from the steps; null: no bar.
  get percent(): number | null {
    if (this.progress !== null) return this.progress;
    return this.totalStages ? Math.min(100, (this.currentStage / this.totalStages) * 100) : null;
  }
}
